import RefContainer from "csi/heading/RefContainer";
import declare from "dojo/_base/declare";

export = declare(RefContainer, {
	bCopy: true,
	onlyCopyToEmpty: true,
});
